module.exports = __webpack_public_path__ + "static/media/cashregister@2x.75738447.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/cashregister@2x.png
// module id = 731
// module chunks = 0